/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import store from '@store';
import admin from './admin';
import { getDeepObj } from '@utils/format';

export const state = {
  app: null,
  akun: getSavedState('akun') || null,
  role: getSavedState('role') || null,
};

export const mutations = {
  SET_APP(state, newValue) {
    state.app = newValue;
  },
  SET_AKUN(state, akun) {
    state.akun = akun || null;
    saveState('akun', akun || null);
  },
  SET_ROLE(state, role) {
    state.role = role;
    saveState('role', role);
  },
};

export const getters = {
  // Whether the user is currently logged in.
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.akun;
  },

  isUcm(state) {
    return Number(getDeepObj(state && state.app, 'attributes.is_ucm')) === 1;
  },
};

export const actions = {
  async logout({ commit }) {
    commit('SET_APP', null);
    commit('SET_AKUN', false);
    commit('SET_ROLE', false);
    // clear local storage
    window.localStorage.clear();

    // unregister module
    const unmodules = admin;
    for (let key in unmodules) {
      if (store && store.state && store.state[key]) {
        store.unregisterModule(key);
      }
    }

    return http.get(`/auth/logout`).then(({ data }) => data);
  },

  async login({ dispatch }, params) {
    const response = await http.post(`/auth/login`, params);
    await dispatch('checkAkun');
    return response.data;
  },

  loginGoogle({}) {
    return `${process.env.VUE_APP_API_URL}/auth/google/callback`;
  },

  async aktivasi({}, params) {
    return http.post(`/aktivasi`, params).then(({ data }) => data);
  },

  async index({}) {
    return http.get(`/`).then(({ data }) => data);
  },

  async langganan({}, params) {
    return http.post(`/langganan`, params).then(({ data }) => data);
  },

  async checkAkun({ state, commit, dispatch }) {
    // If we have the account, we don't need to call the API again.
    // However, if we have a role but modules aren't registered (refresh case),
    // we should still ensure they are registered.
    if (state.akun && state.role) {
      const modulesRegistered = store.state.preferensi !== undefined;
      if (!modulesRegistered) {
        await dispatch('setRole', state.role);
      }
      return Promise.resolve(state.akun);
    }

    const { data } = await dispatch('index');
    const { tenant, akun } = data;

    // set app
    commit('SET_APP', tenant);

    // set akun
    commit('SET_AKUN', akun);
    if (!akun || akun === null) return Promise.resolve(akun);

    const role = 'admin';
    return dispatch('setRole', role);
  },

  setRole({ commit, dispatch, rootState }, role) {
    // register module
    const modules = admin;
    let registered = false;
    for (let key in modules) {
      if (!(store && store.state && store.state[key])) {
        store.registerModule(key, modules[key]);
        registered = true;
      }
    }

    commit('SET_ROLE', role);
    const preferensi = (rootState.preferensi && rootState.preferensi.preferensi) || null;
    // Always fetch preference if we just registered modules or if preference is missing
    return preferensi && !registered
      ? Promise.resolve(preferensi)
      : dispatch('preferensi/getPreferensi', null, { root: true });
  },
};

// ===
// Private helpers
// ===
function getSavedState(key) {
  try {
    const stored = window.localStorage.getItem(key);
    if (stored === 'undefined' || stored === null) return null;
    return JSON.parse(stored);
  } catch (e) {
    return null;
  }
}

function saveState(key, state) {
  if (state === undefined) return;
  window.localStorage.setItem(key, JSON.stringify(state));
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
